import { createFileRoute, redirect } from "@tanstack/react-router"

// The Worker handles direct requests; this also covers client-side navigation.
export const Route = createFileRoute("/about/cli/")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: `/features/cli${location.searchStr}${location.hash ? `#${location.hash}` : ""}`,
      statusCode: 308,
    })
  },
})
